<template>
  <b-row>

    <!-- Small -->


    <!-- Large -->
    <b-col cols="12">
      <b-form-group>
        <v-select v-if="categories != null" v-model="selected" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          label="name" :options="categories" class="select-size-lg" multiple />
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BFormGroup } from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import axios from '@axios'
export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    vSelect,
  },
  created() {
    this.fetchCategories()

  },
  props: {
    initialCategories: []
  },


  methods: {
    updateSelections(a) {

      console.log(a)
    },
    fetchCategories() {
      return new Promise((resolve, reject) => {
        axios
          .get('/countries')
          .then((response) => {

            var data = response.data;
            var responseData = JSON.parse(JSON.stringify(data));
            this.categories = responseData;

          }
          )
          .catch(error => reject(error))
      })
    },
  },
  watch: {
    selected: function (newVal, coldVal) {

      this.$emit("countrySelected", newVal);

    }
  },
  data() {
    return {
      categories: null,
      selected: this.initialCategories,
      option: [{ title: 'Square' }, { title: 'Rectangle' }, { title: 'Rombo' }, { title: 'Romboid' }],
    }
  }


}
</script>